<template>
  <v-container class="container-view" fluid>
    <v-row class="d-flex align-center justify-center flex-wrap text-center">
      <h1 class="text-color font-futura">
        {{ this.$t("services-and-benefits") }}
      </h1>
    </v-row>
    <v-row class="mb-5">
      <v-col cols="12">
        <v-table class="elevation-1 service-table">
          <thead>
            <tr class="header-background-first">
              <th class="text-center column-main" width="50%"></th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 1</div>
                <div class="text-caption">à partir de 500k€ CA</div>
              </th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 2</div>
                <div class="text-caption">à partir de 800k€ CA</div>
              </th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 3</div>
                <div class="text-caption">à partir de 1.3M€ CA</div>
              </th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 4</div>
                <div class="text-caption">à partir de 2.2M€ CA</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in services"
              :key="item.title"
              class="font-egyptienne"
            >
              <td class="pb-3 column-main">
                <v-row>
                  <v-col cols="11">
                    <div>
                      {{ item.title }}
                    </div>
                    <div>
                      {{ item.subtitle }}
                    </div>
                    <div
                      v-if="item.secondSubtitle"
                      class="text-subtitle-2 font-egyptienne"
                    >
                      {{ item.secondSubtitle }}
                    </div>
                  </v-col>
                  <v-col cols="1" class="d-flex align-center justify-start">
                    <div v-if="item.link">
                      <v-btn
                        class="text-color font-egyptienne"
                        :icon="mdiFileEye"
                        @click="openLink(item.link, item.title)"
                      ></v-btn>
                    </div>
                  </v-col>
                </v-row>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <div>
                  <v-icon
                    :color="item.statut1 ? '#ffb500' : '#b2b4ae'"
                    :icon="
                      item.statut1 == true
                        ? mdiCheckBold
                        : item.statut1 == 'cart'
                        ? mdiCart
                        : mdiCloseThick
                    "
                    size="40"
                  ></v-icon>
                </div>
                <div v-if="item.statut1 == false" class="text-caption">
                  PAYABLE EN POINT
                </div>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <div>
                  <v-icon
                    :color="item.statut2 ? '#ffb500' : '#b2b4ae'"
                    :icon="
                      item.statut2 == true
                        ? mdiCheckBold
                        : item.statut2 == 'cart'
                        ? mdiCart
                        : mdiCloseThick
                    "
                    size="40"
                  ></v-icon>
                </div>
                <div v-if="item.statut2 == false" class="text-caption">
                  PAYABLE EN POINT
                </div>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <v-icon
                  :color="item.statut3 ? '#ffb500' : '#b2b4ae'"
                  :icon="
                    item.statut3 == true
                      ? mdiCheckBold
                      : item.statut3 == 'cart'
                      ? mdiCart
                      : mdiCloseThick
                  "
                  size="40"
                ></v-icon>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <v-icon
                  :color="item.statut4 ? '#ffb500' : '#b2b4ae'"
                  :icon="
                    item.statut4 == true
                      ? mdiCheckBold
                      : item.statut4 == 'cart'
                      ? mdiCart
                      : mdiCloseThick
                  "
                  size="40"
                ></v-icon>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>

      <v-row
        class="d-flex align-center justify-center flex-wrap text-center pt-5 pb-5"
      >
        <h1 class="text-color font-futura">
          {{ this.$t("points-calculation") }}
        </h1>
      </v-row>

      <v-col cols="12">
        <v-table class="elevation-1 service-table">
          <thead>
            <tr class="header-background">
              <th class="text-center column-main" width="50%"></th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 1</div>
                <div class="text-caption">à partir de 500k€ CA</div>
              </th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 2</div>
                <div class="text-caption">à partir de 800k€ CA</div>
              </th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 3</div>
                <div class="text-caption">à partir de 1.3M€ CA</div>
              </th>
              <th
                class="text-center column-status font-egyptienne"
              >
                <div>STATUT 4</div>
                <div class="text-caption">à partir de 2.2M€ CA</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in points"
              :key="item.title"
              class="font-egyptienne"
            >
              <td class="pb-3 column-main">
                <div>
                  {{ item.title }}
                </div>
                <div>
                  {{ item.subtitle }}
                </div>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <div>
                  {{ item.statut1 }}
                </div>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <div>
                  {{ item.statut2 }}
                </div>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <div>
                  {{ item.statut3 }}
                </div>
              </td>
              <td class="pb-3 pt-3 text-center column-status">
                <div>
                  {{ item.statut4 }}
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>
    <show-link-dialog
      :modelDialog="showLinkModel"
      :link="selectedLink"
      :title="selectedTitle"
      @close="closeLink"
    ></show-link-dialog>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
import { mdiCheckBold, mdiCloseThick, mdiFileEye, mdiCart } from "@mdi/js";
import ShowLinkDialog from "@/components/ShowLinkDialog.vue";

export default defineComponent({
  name: "HomeView",
  components: { ShowLinkDialog },
  data() {
    return {
      mdiCheckBold,
      mdiCloseThick,
      mdiFileEye,
      mdiCart,
      showLinkModel: false,
      selectedTitle: "",
      selectedLink: "",
      services: [
        {
          title: this.$t("services-benefits.first.title"),
          subtitle: this.$t("services-benefits.first.description"),
          statut1: true,
          statut2: true,
          statut3: true,
          statut4: true,
          link: null,
        },
        {
          title: this.$t("services-benefits.second.title"),
          subtitle: this.$t("services-benefits.second.description"),
          statut1: true,
          statut2: true,
          statut3: true,
          statut4: true,
          link: null,
        },
        {
          title: this.$t("services-benefits.third.title"),
          subtitle: this.$t("services-benefits.third.description"),
          statut1: true,
          statut2: true,
          statut3: true,
          statut4: true,
          link: null,
        },
        {
          title: this.$t("services-benefits.fourth.title"),
          subtitle: this.$t("services-benefits.fourth.description"),
          statut1: false,
          statut2: false,
          statut3: true,
          statut4: true,
          link: null,
        },
        {
          title: this.$t("services-benefits.fifth.title"),
          subtitle: this.$t("services-benefits.fifth.description"),
          secondSubtitle: this.$t("point-order"),
          statut1: "cart",
          statut2: "cart",
          statut3: "cart",
          statut4: "cart",
          link: "RAAC",
        },
        {
          title: this.$t("services-benefits.sixth.title"),
          subtitle: this.$t("services-benefits.sixth.description"),
          secondSubtitle: this.$t("point-order"),
          statut1: "cart",
          statut2: "cart",
          statut3: "cart",
          statut4: "cart",
          link: "HDJ",
        },
        {
          title: this.$t("services-benefits.seventh.title"),
          subtitle: this.$t("services-benefits.seventh.description"),
          secondSubtitle: this.$t("point-order"),
          statut1: "cart",
          statut2: "cart",
          statut3: "cart",
          statut4: "cart",
          link: "AUDIT",
        },
      ],
      points: [
        {
          title: "EQUIPEMENTS ET ANCILLAIRES",
          subtitle:
            "Cumul de points pour l’achat de produits Stryker par tranche de 100 €",
          statut1: "1 point",
          statut2: "2 points",
          statut3: "2 points",
          statut4: "3 points",
        },
        {
          title: "CONTRATS PROCARE",
          subtitle:
            "Cumul de points pour l’achat de produits Stryker par tranche de 100 €",
          statut1: "1 point",
          statut2: "2 points",
          statut3: "2 points",
          statut4: "3 points",
        },
        {
          title: "CONSOMMABLES",
          subtitle:
            "Cumul de points pour l’achat de produits Stryker par tranche de 100 €",
          statut1: "3 points",
          statut2: "5 points",
          statut3: "6 points",
          statut4: "9 points",
        },
        {
          title: "IMPLANTS",
          subtitle:
            "Cumul de points pour l’achat de produits Stryker par tranche de 100 €",
          statut1: "3 points",
          statut2: "5 points",
          statut3: "6 points",
          statut4: "9 points",
        },
      ],
    };
  },
  methods: {
    openLink(link, title) {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("showLink", link)
        .then(() => {
          this.$store.commit("setOverlay", false);
          this.selectedLink = link;
          this.selectedTitle = title;
          this.showLinkModel = true;
        })
        .catch(() => {
          this.$store.dispatch("showSnackbar", {
            message: this.$t("errors.file"),
            color: "error",
          });
          this.$store.commit("setOverlay", false);
          this.$store.commit("setLinkedFile", []);
        });
    },
    closeLink() {
      this.showLinkModel = false;
      this.selectedLink = null;
      this.selectedTitle = null;
      this.$store.commit("setLinkedFile", []);
    },
  },
});
</script>

<style>
.header-background-first {
  background-color: #ffb500;
}

.header-background {
  background-color: #b2b4ae;
}

.text-color {
  color: #ffb500;
}

.service-table .column-main {
  width: 45%;
}

.service-table .column-status {
  width: 15%;
  text-align: center;
}
</style>
